<template>
    <DetailFrame>
        <template>
            <div class="pad15 instStudioList" id="instStudioList">
                <div class="">
                    <el-tabs v-model="activeName" @tab-click="search">
                        <el-tab-pane name="first">
                            <template v-slot:label>
                                <b class="tabTitle">艺术专业单位</b>
                            </template>
                        </el-tab-pane>
                        <el-tab-pane name="second">
                            <template v-slot:label>
                                <b class="tabTitle">共享行动单位</b>
                            </template>
                        </el-tab-pane>
                    </el-tabs>
                    <div>
                        <div v-if="activeName=='first'">
                            <div>
                                <el-input v-model="searchText1" class="searchInput" placeholder="搜索单位名称" clearable @input="search1"></el-input>
                            </div>
                            <div class="list-box list-box1 mb15">
                                <div class="list-item myflex-v" v-for="(cItem1,cIndex1) in studioList" :key="cIndex1" @click="toStudioDetail(cItem1.id)">
                                <el-image :src="art.addOssResize(cItem1.studioPhoto,100)" lazy class="list-cover mr15" @click="art.delayRollAuto()"></el-image>
                                    <div class="flex1 list-main">
                                        <div class="fon14 ellipsis1 mb5">
                                            <span class="fweight mr10">{{cItem1.studioName}}</span>
                                            <span class="list-label">{{studioLevels[cItem1.studioLevel-1].label}}</span>
                                        </div>
                                        <div class="mb5">专业：{{cItem1.majorNames ? cItem1.majorNames : '暂无~'}}</div>
                                        <div v-if="cItem1.studioLevel==3 && cItem1.labelNames" class="myflex-v flexWrap">
                                            <span v-for="(li,liIndex) in cItem1.labelNames.split(',')" :key="liIndex" class="labelIconItem myflex-v">
                                                <img src="@/assets/img/labelcon.png" lazy class="labelcon"/>
                                                <span>{{li}}</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <el-pagination
                                background
                                :pager-count="5"
                                @current-change="currentChange1"
                                :current-page.sync="pageNum1"
                                :page-size="pageSize1"
                                layout="prev, pager, next"
                                :total="total1">
                            </el-pagination>
                        </div>
                        <div v-if="activeName=='second'">
                            <div class="map w-100 mb10" v-if="false">
                                <div class="my-map" id="my-map"></div>
                            </div>
                            <!-- <div class="list-box list-box2 mb15" ref="listBox2">
                                <div class="list-item myflex-v" v-for="(cItem2,cIndex2) in instList" :key="cIndex2" @click="toInstDetail(cItem2.id,cItem2.userId)">
                                    <el-image :src="art.addOssResize(cItem2.studioPhoto ? cItem2.studioPhoto : art.defaultInstCover,100)" class="list-cover mr15" @click="art.delayRollAuto()"></el-image>
                                    <div class="flex1" :src="art.addOssResize(cItem2.studioPhoto,100)">
                                        <div class="fweight fon14 ellipsis1 mb5">{{cItem2.studioName}}</div>
                                        <div class="cor999 ellipsis1">专业：{{cItem2.majorNames ? cItem2.majorNames : '暂无~'}}</div>
                                        <div class="cor999 ellipsis1">
                                            <i class="el-icon-location-outline mr3 fon14"></i>
                                            {{cItem2.province}}{{cItem2.city}}{{cItem2.area}}{{cItem2.studioAddressDetail}}
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                            <div>
                                <el-input v-model="searchText2" class="searchInput" placeholder="搜索单位名称及序号" clearable @input="search2"></el-input>
                            </div>
                            <div class="list-box list-box2 mb15" ref="listBox2">
                                <div class="list-item myflex-v" v-for="(cItem2,cIndex2) in instList" :key="cIndex2" @click="toStudioDetail(cItem2.id)">
                                <el-image :src="art.addOssResize(cItem2.studioPhoto,100)" lazy class="list-cover mr15" @click="art.delayRollAuto()"></el-image>
                                    <div class="flex1 list-main">
                                        <div class="fon14 ellipsis1 mb5">
                                            <span class="fweight mr10">{{cItem2.studioName}}</span>
                                            <span class="list-label">{{studioLevels[cItem2.studioLevel-1].label}}</span>
                                        </div>
                                        <div class="mb5">专业：{{cItem2.majorNames ? cItem2.majorNames : '暂无~'}}</div>
                                        <div v-if="cItem2.studioLevel==3 && cItem2.labelNames" class="myflex-v flexWrap">
                                            <span v-for="(li,liIndex) in cItem2.labelNames.split(',')" :key="liIndex" class="labelIconItem myflex-v">
                                                <img src="@/assets/img/labelcon.png" lazy class="labelcon"/>
                                                <span>{{li}}</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <el-pagination
                                background
                                :pager-count="5"
                                @current-change="currentChange2"
                                :current-page.sync="pageNum2"
                                :page-size="pageSize2"
                                layout="prev, pager, next"
                                :total="total2">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
            
        </template>
    </DetailFrame>
</template>

<style lang="scss" scoped>
    .map{width:100%;height:240px;border:1px solid #ddd;background:#ebebeb;}
    .searchHead{border-bottom:1px solid #aaa;}
    .searchItem{padding-bottom:10px;cursor:pointer;font-weight:600;font-size:16px;margin-right:30px;}
    .searchItem.active{color:$theme-color;}
    .list-item{border-bottom:1px dotted #ddd;padding:10px 10px 10px 0;cursor:default;}
    .list-cover{width:100px;height:76px;min-width:100px;border:1px solid #ddd;}
    .list-label{border-radius:1px;background:#ddd;color:#333;font-size:12px;padding:1px 4px;display:inline-block;}
    .my-map{width:100%;height:100%;}
    .list-box{height:auto;}
    .list-box .list-cover{width:76px;height:76px;min-width:76px;}
    .list-main{overflow:hidden;}
    .labelIconItem{color:rgba(243,120,59,1);background:#fef1eb;font-size:12px;padding:0px 4px 0 0px;line-height:1;margin:2px 6px 2px 6px;border-radius:2px;}
    .labelcon{height:17px;position:relative;left:-5px;}
    .searchInput{width:250px;margin-bottom:15px;}
    @media screen and(max-width:800px){
        .instStudioList{padding:0 !important;}
        .searchInput{width:100%;}
    }
    
</style>

<script>
import { mapState } from 'vuex';
import DetailFrame from "@/components/DetailFrame.vue";
import CourseListItem from '@/components/CourseListItem.vue';
import axios from '@/axios'; // 导入axios实例
import qs from 'qs'; // 根据需求是否导入qs模块

export default {
    name: "instStudioList",
    components: {
        CourseListItem,
        DetailFrame,
    },
    data(){
        return {
            art: art,
            searchval: '',
            studioList: [],
            instList: [],
            instListForMap: [],
            map: null,
            activeName: 'first',
            searchText1: '', //艺术专业单位搜索
            searchText2: '', //共享行动单位
            pageNum1: 1,
            pageSize1: 10,
            total1: 0,
            pageNum2: 1,
            pageSize2: 10,
            total2: 0,
            search1Timer: null,
            search2Timer:  null,

            mapHasInited: false, //地图是否初始化

            studioLevels:[],
        }
    },
    computed:{
        cityName: {
            get: function () {
                let cityInfo = this.$store.getters['cityInfo/getCityInfoFromStorage'];
                console.log(this.$store.getters['cityInfo/getCityInfoFromStorage']);
                return cityInfo ? cityInfo.cityName : '';
            },
            set: function (v) {
            }
        },
        cityPoint: {
            get: function () {
                let cityInfo = this.$store.getters['cityInfo/getCityInfoFromStorage'];
                return cityInfo ? cityInfo.cityPoint : '';
            },
            set: function (v) {
            }
        }
    },
    watch:{
        cityName(newval,oldval){
            if(!this.map) return;
            this.map.centerAndZoom(new BMap.Point(this.cityPoint.lng,this.cityPoint.lat), 11);
        } 
    },
    methods: {

        //切换tab
        search: function(obj){
            
            if( obj.paneName=='second' ){
                if( !this.mapHasInited ){
                    if( this.cityPoint ){
                        if(this.map){
                            this.map.centerAndZoom(this.cityName, 11);
                            this.mapHasInited = true;
                        };
                    }
                }
            }
        },

        startSearch: function(){
            console.log('search');
        },

        //获取美育美育地图上的机构列表
        getInstListForMap(){
            var data = {
                city: this.cityName,
            }
            this.$api.inst.userAddressSelectAllUserAddressDetailList2(data).then(res=>{
                this.instListForMap = res.body.DataList;
                this.addPoint();
            }).catch(res=>{})
        },

        search1(){
            var vm = this;
            if(vm.search1Timer) clearTimeout(vm.search1Timer);
            vm.search1Timer = setTimeout(()=>{
                vm.getStudioList(1);
            },600)
        },
        search2(){
            var vm = this;
            if(vm.search2Timer) clearTimeout(vm.search2Timer);
            vm.search2Timer = setTimeout(()=>{
                vm.getInstList(1);
            },600)
        },

        //获取本地机构列表
        getInstList(page){
            var vm = this;
            var pageNum = page ? page : vm.pageNum2;
            var data = {
                city: this.cityName,
                pageNum: pageNum,
                pageSize: this.pageSize2,
                keyword: vm.searchText2,
            }
            this.$api.web.artmapOfStudioEvaluationSelectStudioAllianceList(data).then(res=>{
                this.instList = res.body.studioList;
                this.pageNum2 = pageNum;
                this.total2 = res.body.total
            }).catch(res=>{})
        },

        //获取工作室列表
        getStudioList(page){
            var vm = this;
            var pageNum = page ? page : vm.pageNum1;
            var data = {
                pageNum: pageNum,
                pageSize: this.pageSize1,
                studioName: vm.searchText1,
            }
            this.$api.inst.artmapOfStudioEvaluationSelectStudioList(data).then(res=>{
                this.studioList = res.body.studioList;
                this.pageNum1 = pageNum;
                this.total1 = res.body.total;
            }).catch(res=>{})
        },

        //机构分页切换
        currentChange2(page){
            this.getInstList(page);
        },

        //工作室分页切换
        currentChange1(page){
            this.getStudioList(page);
        },

        //跳转到机构详情
        toInstDetail(id,userId){
            const newurl = this.$router.resolve({name: 'instDetail', query: {id: id, userId:userId, v:1}})
            window.open(newurl.href,'_blank');
        },

        //跳转到工作室详情
        toStudioDetail(id,userId){
            const newurl = this.$router.resolve({path: '/studioDetail', query: {id: id}})
            window.open(newurl.href,'_blank');
        },

        //跳到单位列表页面
        toList(){
            const newurl = this.$router.resolve({path: '/companyList', query: {}})
            window.open(newurl.href,'_blank');
        },

        //初始化地图
        initMap(){
            //百度地图
            this.map = new BMap.Map("my-map");
            var map = this.map;
            map.centerAndZoom('武汉', 10);
            map.enableScrollWheelZoom();
            map.enableContinuousZoom();
            // 添加带有定位的导航控件
            var navigationControl = new BMap.NavigationControl({
                // 靠左上角位置
                anchor: BMAP_ANCHOR_TOP_LEFT,
                // LARGE类型
                type: BMAP_NAVIGATION_CONTROL_LARGE,
                // 启用显示定位
                enableGeolocation: true
            });
            map.addControl(navigationControl);
            // 添加定位控件
            var geolocationControl = new BMap.GeolocationControl();
            geolocationControl.addEventListener("locationSuccess", function(e){
                // 定位成功事件
                var address = '';
                address += e.addressComponent.province;
                address += e.addressComponent.city;
                address += e.addressComponent.district;
                address += e.addressComponent.street;
                address += e.addressComponent.streetNumber;
            });
            geolocationControl.addEventListener("locationError",function(e){
                // 定位失败事件
                this.$message(e.message);
            });
            map.addControl(geolocationControl);
        },

        //地图上加点
        addPoint(){
            // 百度地图API功能	
            var map = this.map;
            //map.centerAndZoom(new BMap.Point(116.417854,39.921988), 15);
            var data_info = this.instListForMap;
            for(var i=0;i<data_info.length;i++){
                var marker = new BMap.Marker(new BMap.Point(data_info[i].lng,data_info[i].lat));  // 创建标注
                var content =
                    '<div onclick="toInstDetail('+data_info[i].id+','+data_info[i].userId+')">\
                        <h4 class="fon16 fweight mb5">'+data_info[i].institutionName+'</h4>\
                        <div class="fon14 cor999">'+(data_info[i].majorName ? data_info[i].majorName : '暂无专业信息')+' | <span>'+data_info[i].address+'</span></div>\
                    </div>';
                map.addOverlay(marker);// 将标注添加到地图中
                addClickHandler(content,marker);
            }
            //添加事件
            function addClickHandler(content,marker){
                marker.addEventListener("click",function(e){
                    openInfo(content,e)
                });
            }
            //打开信息框
            function openInfo(content,e){
                var p = e.target;
                var point = new BMap.Point(p.getPosition().lng, p.getPosition().lat);
                var infoWindow = new BMap.InfoWindow(content);  // 创建信息窗口对象 
                map.openInfoWindow(infoWindow,point);
            }
        },
    },

    created: function(){
        var activeName = this.$route.query.activeName;
        let searchText2 = this.$route.query.searchText2;
        console.log(this.$route.query);
        if(activeName) this.activeName = activeName;
        if(searchText2) this.searchText2 = decodeURIComponent(searchText2);
        
        window.toInstDetail = this.toInstDetail;
        //工作室等级
        art.getStudioLevels(res=>{
            this.studioLevels = res;
        })
        this.getStudioList(); //获取工作室列表
        setTimeout(()=>{
            this.getInstList();
        },50)
    },
    mounted: function(){
        var vm = this;
        return;
        this.initMap(); //初始化地图
        if( !this.cityName ){
            vm.$store.getters['cityInfo/baiduLocation']((res)=>{
                vm.cityName = res;
                vm.getInstList();
                vm.getInstListForMap();
            })
        }else{
            vm.getInstList();
            vm.getInstListForMap();
        }
    }
}
</script>